import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import React from "react";

type Props = WidgetProps & HasShellContext & HasProduct;

const QuantityWrapper = ({ id, shellContext: { isInShell }, productInfo: { pricing } }: Props) => {
    const isPutUpPrice = pricing?.additionalResults?.spools;

    if (isInShell) {
        return (
            <StyledWrapper>
                <Accordion headingLevel={3}>
                    <AccordionSection title="Zone: Regular Price">
                        <Zone contentId={id as never} zoneName={"RegularPrice" as never} />
                    </AccordionSection>
                    <AccordionSection title="Zone: Putup Price">
                        <Zone contentId={id as never} zoneName={"PutupPrice" as never} />
                    </AccordionSection>
                </Accordion>
            </StyledWrapper>
        );
    }
    if (isPutUpPrice) {
        return <Zone contentId={id as never} zoneName={"PutupPrice" as never} />;
    }
    return <Zone contentId={id as never} zoneName={"RegularPrice" as never} />;
};
const widgetModule: WidgetModule = {
    component: withProduct(withIsInShell(QuantityWrapper)) as any,
    definition: {
        group: "Product Details",
        displayName: "Quantity Wrapper",
        allowedContexts: ["ProductDetailsPage"],
    },
};
export default widgetModule;
